import { motion } from 'framer-motion'
import { Loader2 } from 'lucide-react'

export default function BuyerIntakeTransition() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="flex flex-col items-center justify-center py-20 space-y-4"
    >
      <Loader2 className="h-8 w-8 text-primary animate-spin" />
      <p className="text-lg font-medium text-foreground">Generating your match profile…</p>
    </motion.div>
  )
}
